module.exports = window["AFFWP"]["portal"]["alpineTable"];